function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.903 12.856c-.46-.8-.456-1.787.013-2.583a3.857 3.857 0 00-.347-7.7H6.427a3.856 3.856 0 100 7.712h.103a7.758 7.758 0 000 2.571h-.103a6.427 6.427 0 010-12.854h5.142a6.43 6.43 0 01.334 12.854zm1.902-7.712c.46.8.455 1.787-.013 2.583a3.857 3.857 0 00.347 7.7h5.142a3.856 3.856 0 100-7.712h-.103a7.758 7.758 0 000-2.57h.103a6.427 6.427 0 010 12.854h-5.142a6.43 6.43 0 01-.334-12.855z",
  fill: "#fff"
});

var SvgLinks = function SvgLinks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 25.708,
    height: 18,
    viewBox: "0 0 25.708 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLinks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/links.84d877e1.svg";
export { ForwardRef as ReactComponent };